import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const BodyClassController = () => {
    const location = useLocation();

    const rootStyle = {
        fontFamily: '"Roboto", sans-serif',
        fontWeight: 500,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        fontSize: '16px',
        backgroundColor: '#f2f2f5',
        display: 'flex',
    };

    useEffect(() => {
        const rootElement = document.getElementById('root');

        if (rootElement) {
            rootElement.style = ''; 
            document.body.className = '';

            switch (location.pathname) {
                case '/pin':
                case '/consent':
                case '/select-certificate':
                    document.body.classList.add('login');
                    Object.assign(rootElement.style, rootStyle); 
                    break;
                default:
                    document.body.classList.add('template-base');
                    break;
            }
        }
    }, [location]);

    return null;
};
